export function isImageExt(filePath: string) {
  return filePath.endsWith('jpeg')
    || filePath.endsWith('jpg')
    || filePath.endsWith('gif')
    || filePath.endsWith('svg')
    || filePath.endsWith('png');
}
